import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import {
    getSettingsCollection,
} from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    LoadRealTimeInventory,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/LoadProductsPricingAndInventory";

const enum pageType {
    productListPage = "Product List Page",
    searchPage = "Search Page",
}


replaceInChain(chain, LoadRealTimeInventory, props => {
    if (
        !props.parameter.products?.length ||
        (getIsWebCrawler() &&
            !getSettingsCollection(props.getState()).websiteSettings.includeRealTimeInventoryAndPricingForSeo)
    ) {
        return;
    }

    const { productInfosByProductId } = props.parameter;

    const productIds = Object.keys(productInfosByProductId).filter(o => !productInfosByProductId[o]?.inventory);
    if (productIds.length === 0) {
        return;
    }

    props.dispatch(
        loadRealTimeInventory({
            productIds,
            expand: ["warehouses"], // Store Custom Code
            onSuccess: realTimeInventory => {
                props.dispatch({
                    type: "Pages/ProductList/CompleteLoadRealTimeInventory",
                    realTimeInventory,
                });
            },
            onError: () => {
                props.dispatch({
                    type: "Pages/ProductList/FailedLoadRealTimeInventory",
                });
            },
            onComplete(realTimeInventoryProps) {
                if (realTimeInventoryProps.apiResult) {
                    this.onSuccess?.(realTimeInventoryProps.apiResult);
                } else if (realTimeInventoryProps.error) {
                    this.onError?.(realTimeInventoryProps.error);
                }
            },
        }),
    );
});

